<div class="d-flex justify-content-end mt-3">
  <nav>
    <ul class="pagination">
      <li>
        <button
          (click)="goToPrevPage()"
          [disabled]="currentPage === 1"
          class="pagination-btn"
          [class.disabled]="currentPage === 1"
          >
          <img src="../../../../assets/icon/back.svg" alt="" />
        </button>
      </li>
      <li class="page-item">
        {{ currentPage }}
        @if (totalPages) {
          <span> / {{ totalPages }}</span>
        }
      </li>
      <li>
        <button
          (click)="goToNextPage()"
          [disabled]="currentPage === totalPages"
          class="pagination-btn"
          [class.disabled]="currentPage === totalPages"
          >
          <img src="../../../../assets/icon/forward.svg" alt="" />
        </button>
      </li>
    </ul>
  </nav>
</div>
